import { render } from "./IconBusSvg.vue?vue&type=template&id=0265c53f"
import script from "./IconBusSvg.vue?vue&type=script&lang=js"
export * from "./IconBusSvg.vue?vue&type=script&lang=js"
script.render = render

export default script